import { render, staticRenderFns } from "./ProcessModelPage.vue?vue&type=template&id=1748a80a&"
import script from "./ProcessModelPage.vue?vue&type=script&lang=js&"
export * from "./ProcessModelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports